var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/verification/components/password-indicator.tsx";
import React, { useEffect, useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Stack } from 'soapbox/components/ui';
import ValidationCheckmark from 'soapbox/components/validation-checkmark';
const messages = defineMessages({
  minimumCharacters: {
    "id": "registration.validation.minimum_characters",
    "defaultMessage": "8 characters"
  },
  capitalLetter: {
    "id": "registration.validation.capital_letter",
    "defaultMessage": "1 capital letter"
  },
  lowercaseLetter: {
    "id": "registration.validation.lowercase_letter",
    "defaultMessage": "1 lowercase letter"
  }
});
const hasUppercaseCharacter = string => {
  for (let i = 0; i < string.length; i++) {
    if (string.charAt(i) === string.charAt(i).toUpperCase() && string.charAt(i).match(/[a-z]/i)) {
      return true;
    }
  }
  return false;
};
const hasLowercaseCharacter = string => {
  return string.toUpperCase() !== string;
};
const PasswordIndicator = ({
  onChange,
  password
}) => {
  const intl = useIntl();
  const meetsLengthRequirements = useMemo(() => password.length >= 8, [password]);
  const meetsCapitalLetterRequirements = useMemo(() => hasUppercaseCharacter(password), [password]);
  const meetsLowercaseLetterRequirements = useMemo(() => hasLowercaseCharacter(password), [password]);
  const hasValidPassword = meetsLengthRequirements && meetsCapitalLetterRequirements && meetsLowercaseLetterRequirements;
  useEffect(() => {
    onChange(hasValidPassword);
  }, [hasValidPassword]);
  return /*#__PURE__*/React.createElement(Stack, {
    className: "mt-2",
    space: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ValidationCheckmark, {
    isValid: meetsLengthRequirements,
    text: intl.formatMessage(messages.minimumCharacters),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ValidationCheckmark, {
    isValid: meetsCapitalLetterRequirements,
    text: intl.formatMessage(messages.capitalLetter),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ValidationCheckmark, {
    isValid: meetsLowercaseLetterRequirements,
    text: intl.formatMessage(messages.lowercaseLetter),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 7
    }
  }));
};
export default PasswordIndicator;